<template>
  <div class="layout-category-products">
    <div class="products">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      functionShowImageFlag: false
    }
  },
  methods:{
    isVisible(elem) {
      var coords = elem.getBoundingClientRect();
      var windowHeight = document.documentElement.clientHeight;
      // верхняя граница elem в пределах видимости ИЛИ нижняя граница видима
      var topVisible = coords.top > 0 && coords.top < windowHeight;
      var bottomVisible = coords.bottom < windowHeight && coords.bottom > 0;
      return topVisible || bottomVisible;
    },
    showVisible() {
      var imgs = document.getElementsByTagName('img');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        var realsrc = img.getAttribute('realsrc');
        if (!realsrc) continue;
        if (this.isVisible(img)) {
          this.functionShowImageFlag = true;
          img.src = realsrc;
          img.setAttribute('realsrc', '');
          img.classList.remove('load');
        }
      }
    }
  },
  created () {
    window.addEventListener('scroll', () => {
      this.showVisible();
    });
  },
  mounted(){
    var showVisibleTimer = setInterval( () => {
      if (!this.functionShowImageFlag) {
        this.showVisible();
      } else {
        clearInterval(showVisibleTimer);
      }
    }, 1000);
  }
}
</script>

<style lang="scss" scoped>
.layout-category-products {
}
.products {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  gap: 15px 15px;
  margin: 0 -0.5em;
  & > * {
    &:hover {
      z-index: 10;
    }
  }
}

@media screen and (max-width: 767px) {
  .products {
    display: block;
    & > * {
      margin-bottom: 2em;
    }
  }
}

@media screen and (max-width: 900px) and (orientation: landscape) {
  .products {
    grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  }
}
</style>